"use strict";
// Marketing plugin, published-site half. Studio's `core.deploy.transform`
// inlines this into the <head> of every production HTML file:
//
//   <script> Consent Mode v2 defaults (denied for opt-in, granted otherwise) </script>
//   <script> window.__DUNEA_MARKETING__ = { appId, consent, tags, whatsapp } </script>
//   <script> MARKETING_RUNTIME_JS </script>
//
// The runtime shows the consent banner, loads only the tags the visitor
// allowed, captures campaign attribution (first + last touch) and exposes
// `window.dunea.{attribution,track,consent,openConsent}`. It never uses
// innerHTML with config strings, and re-validates every tag id against the
// MARKETING_TAGS patterns before building a script URL (defense in depth on
// top of studio's validation). Pure: no dependencies, plain ES2017.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKETING_RUNTIME_JS = void 0;
exports.scriptSafeJson = scriptSafeJson;
exports.sanitizeMarketingRuntimeConfig = sanitizeMarketingRuntimeConfig;
exports.renderMarketingHead = renderMarketingHead;
exports.whatsAppDigits = whatsAppDigits;
exports.whatsAppUrl = whatsAppUrl;
exports.renderWhatsAppButton = renderWhatsAppButton;
const marketing_1 = require("../catalog/marketing");
/** provider id → { public field key → pattern }. Secret fields are never part of the runtime. */
const RUNTIME_PATTERNS = Object.fromEntries(marketing_1.MARKETING_TAGS.map((t) => [
    t.id,
    Object.fromEntries(t.fields.filter((f) => !f.secret).map((f) => [f.key, f.pattern])),
]));
const RUNTIME_CONSENT = Object.fromEntries(marketing_1.MARKETING_TAGS.map((t) => [t.id, t.consent]));
/** JSON that is safe inside an inline <script> (no </script>, <!--, or JS line terminators). */
function scriptSafeJson(value) {
    return JSON.stringify(value)
        .replace(/</g, '\\u003c')
        .replace(/>/g, '\\u003e')
        .replace(/&/g, '\\u0026')
        .replace(/\u2028/g, '\\u2028')
        .replace(/\u2029/g, '\\u2029');
}
const RUNTIME_BODY = String.raw `
var w = window, d = document;
if (w.__duneaMarketing) { return; }
w.__duneaMarketing = true;
var cfg = w.__DUNEA_MARKETING__ || {};
var cc = cfg.consent || {};
var CONSENT_ON = cc.enabled === true;
var OPT_IN = CONSENT_ON && cc.mode !== 'notice';
var CK = 'dunea_consent', AK = 'dunea_attribution';
var TTL = 90 * 864e5, CONSENT_TTL = 395 * 864e5;
var loaded = {}, tags = [];

function get(k) { try { var v = w.localStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
function put(k, v) { try { w.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage blocked */ } }
function cookie(n) { var m = d.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : undefined; }
function uuid() {
  if (w.crypto && w.crypto.randomUUID) { return w.crypto.randomUUID(); }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16); });
}
function gtag() { w.dataLayer = w.dataLayer || []; if (w.gtag) { w.gtag.apply(w, arguments); } else { w.dataLayer.push(arguments); } }
function script(src) { var s = d.createElement('script'); s.async = true; s.src = src; (d.head || d.documentElement).appendChild(s); }

(Array.isArray(cfg.tags) ? cfg.tags : []).forEach(function (t) {
  var p = t && PATTERNS[t.provider];
  if (!p || !t.values) { return; }
  var v = {}, ok = true;
  Object.keys(p).forEach(function (k) {
    var x = t.values[k];
    if (x === undefined || x === '') { return; }
    if (typeof x !== 'string' || !new RegExp(p[k]).test(x)) { ok = false; } else { v[k] = x; }
  });
  var main = MAIN[t.provider];
  if (ok && v[main]) { tags.push({ provider: t.provider, consent: CATEGORY[t.provider], values: v }); }
});

function consent() {
  if (!CONSENT_ON) { return { analytics: true, marketing: true }; }
  var s = get(CK);
  if (s && typeof s.analytics === 'boolean' && Date.now() - (s.at || 0) < CONSENT_TTL) { return { analytics: s.analytics, marketing: s.marketing === true }; }
  return OPT_IN ? { analytics: false, marketing: false } : { analytics: true, marketing: true };
}
function signal(c) {
  var a = c.analytics ? 'granted' : 'denied', m = c.marketing ? 'granted' : 'denied';
  gtag('consent', 'update', { analytics_storage: a, ad_storage: m, ad_user_data: m, ad_personalization: m });
}

var gtagLoaded = false;
function gtagJs(id) { if (!gtagLoaded) { gtagLoaded = true; script('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id)); gtag('js', new Date()); } }
var LOAD = {
  'ga4': function (v) { gtagJs(v.measurementId); gtag('config', v.measurementId); },
  'google-ads': function (v) { gtagJs(v.conversionId); gtag('config', v.conversionId); },
  'meta-pixel': function (v) {
    if (!w.fbq) {
      var n = w.fbq = function () { if (n.callMethod) { n.callMethod.apply(n, arguments); } else { n.queue.push(arguments); } };
      if (!w._fbq) { w._fbq = n; }
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
      script('https://connect.facebook.net/en_US/fbevents.js');
    }
    w.fbq('init', v.pixelId); w.fbq('track', 'PageView');
  },
  'tiktok-pixel': function (v) {
    w.TiktokAnalyticsObject = 'ttq';
    var q = w.ttq = w.ttq || [];
    ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'].forEach(function (m) {
      q[m] = function () { q.push([m].concat(Array.prototype.slice.call(arguments, 0))); };
    });
    q._i = q._i || {}; q._i[v.pixelId] = []; q._t = q._t || {}; q._t[v.pixelId] = +new Date();
    script('https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=' + encodeURIComponent(v.pixelId) + '&lib=ttq');
    q.page();
  },
  'linkedin-insight': function (v) {
    w._linkedin_partner_id = v.partnerId;
    (w._linkedin_data_partner_ids = w._linkedin_data_partner_ids || []).push(v.partnerId);
    if (!w.lintrk) { var l = w.lintrk = function (a, b) { l.q.push([a, b]); }; l.q = []; }
    script('https://snap.licdn.com/li.lms-analytics/insight.min.js');
  },
  'microsoft-clarity': function (v) {
    w.clarity = w.clarity || function () { (w.clarity.q = w.clarity.q || []).push(arguments); };
    script('https://www.clarity.ms/tag/' + encodeURIComponent(v.projectId));
  },
  'google-tag-manager': function (v) {
    (w.dataLayer = w.dataLayer || []).push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    script('https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(v.containerId));
  }
};
function loadAllowed() {
  var c = consent();
  tags.forEach(function (t) {
    if (loaded[t.provider] || !c[t.consent]) { return; }
    loaded[t.provider] = t;
    try { LOAD[t.provider](t.values); } catch (e) { /* one tag never breaks the others */ }
  });
}

// ─── attribution ───
var UTM = { utm_source: 'source', utm_medium: 'medium', utm_campaign: 'campaign', utm_term: 'term', utm_content: 'content', gclid: 'gclid', fbclid: 'fbclid', ttclid: 'ttclid', msclkid: 'msclkid' };
function clean(s) { return String(s).replace(/[\u0000-\u001f<>"'\x60]/g, '').trim().slice(0, 200); }
function capture() {
  var q = new URLSearchParams(w.location.search), touch = {}, fresh = false;
  Object.keys(UTM).forEach(function (k) { var v = q.get(k); if (v && clean(v)) { touch[UTM[k]] = clean(v); fresh = true; } });
  if (!touch.source && d.referrer) {
    try {
      var h = new URL(d.referrer).hostname.replace(/^www\./, '');
      if (h && h !== w.location.hostname.replace(/^www\./, '')) { touch.referrer = clean(h); fresh = true; }
    } catch (e) { /* bad referrer */ }
  }
  touch.landingPath = clean(w.location.pathname);
  var now = Date.now(), st = get(AK) || {};
  touch.at = now;
  if (!st.first || !(now - st.first.at < TTL)) { st.first = touch; }
  if (fresh || !st.last) { st.last = touch; }
  put(AK, st);
}
function attribution() {
  var st = get(AK) || {}, last = st.last || {}, out = {};
  ['source', 'medium', 'campaign', 'term', 'content', 'gclid', 'fbclid', 'ttclid', 'msclkid', 'referrer', 'landingPath'].forEach(function (k) { if (last[k]) { out[k] = last[k]; } });
  if (st.first && st.first.at) { out.firstTouchAt = new Date(st.first.at).toISOString(); }
  var ga = cookie('_ga');
  if (ga) { var parts = ga.split('.'); if (parts.length >= 4) { out.gaClientId = parts.slice(-2).join('.'); } }
  var fbp = cookie('_fbp'), fbc = cookie('_fbc');
  if (fbp) { out.fbp = fbp; }
  if (fbc) { out.fbc = fbc; } else if (last.fbclid) { out.fbc = 'fb.1.' + last.at + '.' + last.fbclid; }
  out.consent = consent();
  out.eventId = uuid();
  return out;
}

// ─── conversions ───
var META = { purchase: 'Purchase', lead: 'Lead', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout', view_content: 'ViewContent', sign_up: 'CompleteRegistration', contact: 'Contact', subscribe: 'Subscribe' };
var TIKTOK = { purchase: 'CompletePayment', lead: 'SubmitForm', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout', view_content: 'ViewContent', sign_up: 'CompleteRegistration', contact: 'Contact', subscribe: 'Subscribe' };
var GA = { lead: 'generate_lead' };
function track(event, props) {
  event = String(event || '');
  if (!/^[A-Za-z0-9_]{1,40}$/.test(event)) { return undefined; }
  props = props && typeof props === 'object' ? props : {};
  var id = typeof props.eventId === 'string' && props.eventId ? props.eventId : uuid();
  var data = {};
  Object.keys(props).forEach(function (k) { if (k !== 'eventId') { data[k] = props[k]; } });
  var c = consent(), money = {};
  if (typeof data.value === 'number') { money.value = data.value; }
  if (typeof data.currency === 'string') { money.currency = data.currency; }
  Object.keys(loaded).forEach(function (p) {
    var t = loaded[p], v = t.values;
    if (!c[t.consent]) { return; }
    try {
      if (p === 'ga4') { gtag('event', GA[event] || event, Object.assign({ event_id: id, send_to: v.measurementId }, data)); }
      if (p === 'google-ads') {
        var label = event === 'purchase' ? v.purchaseLabel : event === 'lead' ? v.leadLabel : undefined;
        if (label) { gtag('event', 'conversion', Object.assign({ send_to: v.conversionId + '/' + label, transaction_id: data.transactionId || id }, money)); }
      }
      if (p === 'meta-pixel' && w.fbq) {
        if (META[event]) { w.fbq('track', META[event], data, { eventID: id }); } else { w.fbq('trackCustom', event, data, { eventID: id }); }
      }
      if (p === 'tiktok-pixel' && w.ttq) { w.ttq.track(TIKTOK[event] || event, data, { event_id: id }); }
      if (p === 'linkedin-insight' && w.lintrk && /^[0-9]{1,15}$/.test(String(data.linkedinConversionId || ''))) { w.lintrk('track', { conversion_id: Number(data.linkedinConversionId) }); }
      if (p === 'microsoft-clarity' && w.clarity) { w.clarity('event', event); }
      if (p === 'google-tag-manager') { w.dataLayer.push(Object.assign({ event: event, event_id: id }, data)); }
    } catch (e) { /* never break the page */ }
  });
  return id;
}

// ─── consent banner ───
var banner = null;
function el(tag, attrs, text) {
  var n = d.createElement(tag);
  Object.keys(attrs || {}).forEach(function (k) { n.setAttribute(k, attrs[k]); });
  if (text) { n.textContent = text; }
  return n;
}
function choose(c) {
  var choice = { analytics: c.analytics === true, marketing: c.marketing === true, at: Date.now() };
  put(CK, choice);
  signal(choice);
  loadAllowed();
  if (banner && banner.parentNode) { banner.parentNode.removeChild(banner); }
  banner = null;
}
function openConsent() {
  if (!CONSENT_ON || banner || !d.body) { return; }
  var c = consent(), pos = cc.position === 'bottom-left' ? 'left:16px;' : cc.position === 'bottom-right' ? 'right:16px;' : 'left:16px;right:16px;margin:0 auto;';
  var btn = 'font:inherit;padding:8px 14px;border-radius:6px;cursor:pointer;border:1px solid #888;background:#fff;color:#111;';
  banner = el('div', { id: 'dunea-consent', role: 'dialog', 'aria-modal': 'false', 'aria-labelledby': 'dunea-consent-title', 'aria-describedby': 'dunea-consent-msg', style: 'position:fixed;bottom:16px;' + pos + 'max-width:420px;z-index:2147483646;background:#fff;color:#111;border:1px solid #ccc;border-radius:10px;padding:16px;box-shadow:0 6px 24px rgba(0,0,0,.18);font:14px/1.45 system-ui,sans-serif;' });
  banner.appendChild(el('h2', { id: 'dunea-consent-title', style: 'margin:0 0 6px;font-size:16px;' }, cc.title || 'Cookies & privacy'));
  var msg = el('p', { id: 'dunea-consent-msg', style: 'margin:0 0 12px;' }, cc.message || 'We use cookies for analytics and to measure our ads. Choose what you allow.');
  if (typeof cc.privacyUrl === 'string' && /^(https?:\/\/|\/(?!\/))/i.test(cc.privacyUrl)) {
    msg.appendChild(d.createTextNode(' '));
    msg.appendChild(el('a', { href: cc.privacyUrl, style: 'color:inherit;text-decoration:underline;' }, 'Privacy policy'));
  }
  banner.appendChild(msg);
  var panel = el('div', { id: 'dunea-consent-options', hidden: '', style: 'margin:0 0 12px;' });
  var boxes = {};
  [['analytics', 'Analytics'], ['marketing', 'Marketing']].forEach(function (o) {
    var lab = el('label', { style: 'display:block;margin:4px 0;' });
    var box = el('input', { type: 'checkbox', name: o[0] });
    box.checked = c[o[0]];
    boxes[o[0]] = box;
    lab.appendChild(box);
    lab.appendChild(d.createTextNode(' ' + o[1]));
    panel.appendChild(lab);
  });
  banner.appendChild(panel);
  var row = el('div', { style: 'display:flex;gap:8px;flex-wrap:wrap;' });
  var reject = el('button', { type: 'button', 'data-consent': 'reject', style: btn }, 'Reject');
  var custom = el('button', { type: 'button', 'data-consent': 'customize', 'aria-expanded': 'false', 'aria-controls': 'dunea-consent-options', style: btn }, 'Customize');
  var accept = el('button', { type: 'button', 'data-consent': 'accept', style: btn + 'background:#111;color:#fff;border-color:#111;' }, 'Accept all');
  reject.onclick = function () { choose({ analytics: false, marketing: false }); };
  accept.onclick = function () { choose({ analytics: true, marketing: true }); };
  custom.onclick = function () {
    if (panel.hasAttribute('hidden')) {
      panel.removeAttribute('hidden'); custom.setAttribute('aria-expanded', 'true'); custom.textContent = 'Save choices';
      boxes.analytics.focus();
    } else {
      choose({ analytics: boxes.analytics.checked, marketing: boxes.marketing.checked });
    }
  };
  row.appendChild(reject); row.appendChild(custom); row.appendChild(accept);
  banner.appendChild(row);
  d.body.appendChild(banner);
  try { accept.focus({ preventScroll: true }); } catch (e) { /* old browsers */ }
}

capture();
var api = w.dunea = w.dunea || {};
api.attribution = attribution;
api.track = track;
api.consent = function () { var c = consent(); return { analytics: c.analytics, marketing: c.marketing }; };
api.openConsent = openConsent;

var stored = CONSENT_ON ? get(CK) : null;
if (stored && typeof stored.analytics === 'boolean') { signal(consent()); }
loadAllowed();
if (CONSENT_ON && !(stored && typeof stored.analytics === 'boolean' && Date.now() - (stored.at || 0) < CONSENT_TTL)) {
  if (d.body) { openConsent(); } else { d.addEventListener('DOMContentLoaded', openConsent); }
}
d.addEventListener('click', function (e) {
  var t = e.target && e.target.closest ? e.target.closest('[data-dunea-track]') : null;
  if (!t) { return; }
  var p = {}, v = parseFloat(t.getAttribute('data-dunea-value') || '');
  if (!isNaN(v)) { p.value = v; }
  var cur = t.getAttribute('data-dunea-currency');
  if (cur && /^[A-Za-z]{3}$/.test(cur)) { p.currency = cur.toUpperCase(); }
  track(t.getAttribute('data-dunea-track'), p);
}, true);
`;
/** The published-site runtime (IIFE). Reads window.__DUNEA_MARKETING__. */
exports.MARKETING_RUNTIME_JS = '(function(){"use strict";' +
    `var PATTERNS=${scriptSafeJson(RUNTIME_PATTERNS)};` +
    `var CATEGORY=${scriptSafeJson(RUNTIME_CONSENT)};` +
    `var MAIN=${scriptSafeJson(Object.fromEntries(marketing_1.MARKETING_TAGS.map((t) => [t.id, t.fields.find((f) => f.required)?.key ?? t.fields[0].key])))};` +
    // Light minification: drop `/* … */` comments and indentation (lines kept, so ASI is unaffected).
    RUNTIME_BODY.replace(/\/\* [^*]* \*\//g, '')
        .split('\n')
        .map((l) => l.trim())
        .filter(Boolean)
        .join('\n') +
    '})();';
/** Only known providers with pattern-valid public ids; normalised consent; no secrets. */
function sanitizeMarketingRuntimeConfig(config) {
    const tags = [];
    for (const t of config.tags ?? []) {
        const patterns = RUNTIME_PATTERNS[t?.provider];
        if (!patterns) {
            continue;
        }
        const values = {};
        for (const [key, pattern] of Object.entries(patterns)) {
            const v = t.values?.[key];
            if (typeof v === 'string' && new RegExp(pattern).test(v)) {
                values[key] = v;
            }
        }
        tags.push({ provider: t.provider, consent: RUNTIME_CONSENT[t.provider], values });
    }
    const c = config.consent ?? {};
    const str = (v, max) => (typeof v === 'string' && v.trim() ? v.trim().slice(0, max) : undefined);
    const consent = {
        enabled: c.enabled === true,
        mode: c.mode === 'notice' ? 'notice' : 'opt-in',
        ...(str(c.title, 120) ? { title: str(c.title, 120) } : {}),
        ...(str(c.message, 600) ? { message: str(c.message, 600) } : {}),
        ...(str(c.privacyUrl, 500) && /^(https?:\/\/|\/(?!\/))/i.test(c.privacyUrl.trim())
            ? { privacyUrl: str(c.privacyUrl, 500) }
            : {}),
        position: c.position === 'bottom-left' || c.position === 'bottom-right' ? c.position : 'bottom',
    };
    return { appId: String(config.appId ?? ''), consent, tags, whatsapp: null };
}
/** Consent Mode v2 defaults + config + runtime, for the end of <head>. */
function renderMarketingHead(config) {
    const clean = sanitizeMarketingRuntimeConfig(config);
    const state = clean.consent.enabled && clean.consent.mode === 'opt-in' ? 'denied' : 'granted';
    const defaults = 'window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments)}' +
        `gtag('consent','default',{ad_storage:'${state}',ad_user_data:'${state}',ad_personalization:'${state}',analytics_storage:'${state}',wait_for_update:500});` +
        (state === 'denied' ? "gtag('set','ads_data_redaction',true);" : '');
    return (`<script data-dunea="consent-defaults">${defaults}</script>` +
        `<script data-dunea="marketing-config">window.__DUNEA_MARKETING__=${scriptSafeJson(clean)};</script>` +
        `<script data-dunea="marketing">${exports.MARKETING_RUNTIME_JS}</script>`);
}
function escapeHtml(s) {
    return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
}
/** "+91 98765-43210" → "919876543210"; null unless 8–15 digits. */
function whatsAppDigits(phone) {
    if (typeof phone !== 'string') {
        return null;
    }
    const digits = phone.replace(/[\s+\-().]/g, '');
    return /^[0-9]{8,15}$/.test(digits) ? digits : null;
}
/** wa.me click-to-chat URL, or null for an invalid phone. */
function whatsAppUrl(settings) {
    const digits = whatsAppDigits(settings.phone);
    if (!digits) {
        return null;
    }
    const text = typeof settings.message === 'string' ? settings.message.trim().slice(0, 500) : '';
    return `https://wa.me/${digits}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
}
/** Floating "Chat on WhatsApp" link for the end of <body>; '' when disabled or invalid. */
function renderWhatsAppButton(settings) {
    const url = settings?.enabled ? whatsAppUrl(settings) : null;
    if (!url) {
        return '';
    }
    const label = escapeHtml((typeof settings.label === 'string' && settings.label.trim() ? settings.label.trim() : 'Chat on WhatsApp').slice(0, 40));
    const side = settings.position === 'bottom-left' ? 'left' : 'right';
    return (`<style>#dunea-whatsapp:focus-visible{outline:3px solid #111;outline-offset:3px}#dunea-whatsapp:hover{filter:brightness(.95)}</style>` +
        `<a id="dunea-whatsapp" href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer" aria-label="${label}"` +
        ` style="position:fixed;bottom:20px;${side}:20px;z-index:2147483645;display:inline-flex;align-items:center;gap:8px;` +
        `padding:12px 16px;border-radius:999px;background:#25D366;color:#fff;font:600 15px/1 system-ui,sans-serif;` +
        `text-decoration:none;box-shadow:0 4px 16px rgba(0,0,0,.2)">` +
        `<svg aria-hidden="true" focusable="false" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">` +
        `<path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3z"/>` +
        `</svg><span>${label}</span></a>`);
}
